import styled from 'styled-components';
import { colors, spacing, transitions, typography } from '../../../styles/theme';

export const TooltipContent = styled.div`
  visibility: hidden;
  opacity: 0;
  pointer-events: none;

  width: 338px !important;
  height: 174px;
  border-radius: 8px;
  border: 1px solid ${colors('neutral.light')};

  background-color: ${colors('white.base')};
  filter: drop-shadow(0px 16px 48px ${colors('black.10')});

  font-weight: ${typography('weights.regular')};
  font-size: ${typography('caption1.fontSize')};
  line-height: ${typography('caption1.lineHeight')};
  color: ${colors('neutral.base')};

  display: flex;
  flex-direction: column;
  align-items: center;

  position: absolute !important;
  right: 8px;
  top: 40px;
  z-index: 15;

  transition: visibility ${transitions('fast')}, opacity ${transitions('fast')};

  .header {
    padding: ${spacing('1')} 0;
    border-bottom: 1px solid ${colors('neutral.light')};
    text-align: center;
  }

  .content {
    height: 100%;
    padding: ${spacing('3')} 0;
    display: flex;
    align-items: flex-start;

    p {
      padding: 0 ${spacing('2')};
    }

    svg {
      padding-left: ${spacing('2')};
    }
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 65%;
    margin-left: ${-spacing('1')};
    width: 0;
    height: 0;
    border-bottom: ${spacing('1')} solid ${colors('white.base')};
    border-right: ${spacing('1')} solid transparent;
    border-left: ${spacing('1')} solid transparent;
  }
`;

export const Tooltip = styled.div`
  position: relative;
  
  &:hover {
    ${TooltipContent} {
      visibility: visible;
      opacity: 1;
    }
  }
`;

